import * as React from 'react';
import './EligibleRowMobile.scss';
import { IEligibleItem } from 'src/services/returns/typings';
import localeFormatingInstance from 'src/translation/localeFormating';

interface IEligibleRowMobileProps {
  eligibleItem: IEligibleItem;

  partsToReturn: IEligibleItem[];
  addItemToReturn: (part: IEligibleItem) => void;
  removeItemFromReturn: (id: number) => void;
  t?: any;
}

const EligibleRowMobile: React.FC<IEligibleRowMobileProps> = props => {
  const {
    eligibleItem,
    partsToReturn,
    addItemToReturn,
    removeItemFromReturn,
    t
  } = props;

  const [quantity, setQuantity] = React.useState<string>('1');
  const [reason, setReason] = React.useState<string>('');
  const [isItemAdded, setIsItemAdded] = React.useState<boolean>(false);

  React.useEffect(() => {
    const index = partsToReturn.findIndex(part => part.id === eligibleItem.id);
    if (index !== -1) {
      setQuantity(String(partsToReturn[index].returnQuantity));
      setReason(partsToReturn[index].reason);
      setIsItemAdded(true);
    } else {
      setIsItemAdded(false);
    }
  }, [partsToReturn]);

  const handleAddItem = () => {
    if (!isItemAdded) {
      addItemToReturn({
        ...eligibleItem,
        reason,
        returnQuantity: Number(quantity)
      });
    } else {
      removeItemFromReturn(eligibleItem.id);
    }
    setIsItemAdded(!isItemAdded);
  };

  return (
    <div className={`rp-eligible-row-mobile ${isItemAdded && 'added'}`}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-4">
            <p className="rp-eligible-row-mobile-header">
             {t('myReturns.partNo')}{' '}
            </p>
          </div>
          <div className="col-4">
            <p className="rp-eligible-row-mobile-header">
              {t('myReturns.invoiceNo')}
            </p>
          </div>
          <div className="col-4">
            <p className="rp-eligible-row-mobile-header">
              {t('myReturns.invoiceDate')}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            <p>{`${
              eligibleItem.manufacturerCode ? eligibleItem.manufacturerCode : ''
            } ${eligibleItem.partNumber}`}</p>
          </div>
          <div className="col-4">
            <p>{eligibleItem.invoiceNumber}</p>
          </div>
          <div className="col-4">
            <p>
              {localeFormatingInstance.formatDate(
                eligibleItem.invoiceDate,
                'short'
              )}
            </p>
          </div>
        </div>
      </div>
      <div className="rp-eligible-row-mobile-button" onClick={handleAddItem}>
        {isItemAdded ? (
          <i className="rpds-remove rp-eligible-row-mobile-remove-icon" />
        ) : (
          <i className="rpds-add rp-eligible-row-mobile-add-icon" />
        )}
      </div>
    </div>
  );
};

export default EligibleRowMobile;
